var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCottageCheese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C8078;}\n\t.st1{fill:#B6D6E9;}\n\t.st2{fill:#6DCAF3;}\n\t.st3{fill:#E6EAEA;}\n\t.st4{fill:#CCD6DD;}\n\t.st5{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.78,62L118.9,91.88c-1.26,1.26-3.32,1.26-4.58,0l0,0c-1.26-1.26-1.26-3.32,0-4.58l29.87-29.87 c1.26-1.26,3.32-1.26,4.58,0v0C150.04,58.68,150.04,60.74,148.78,62z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M105.49,157.26c-40.47,0-45.99-40.58-45.99-51.4h91.99C151.48,111.27,146.19,157.26,105.49,157.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M151.48,106.01c0,14.11-20.59,25.55-45.99,25.55c-25.4,0-45.99-11.44-45.99-25.55s20.59-25.55,45.99-25.55 C130.89,80.46,151.48,91.9,151.48,106.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.49,127.5c-16.23,0-43.29-8.12-43.29-21.64c0-16.23,16.57-35.17,43.29-35.17s43.29,21.64,43.29,35.17 C148.78,119.39,124.43,127.5,105.49,127.5"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 79.22,
    cy: 78.49,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 122.19,
    cy: 74.65,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 87.14,
    cy: 75.85,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 67.58,
    cy: 93.73,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 128.67,
    cy: 79.45,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 136.35,
    cy: 82.57,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 100.1,
    cy: 72.01,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 109.22,
    cy: 70.81,
    r: 5.52
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 108.89,
    cy: 112.49,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 94.85,
    cy: 100.06,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 124.74,
    cy: 87.82,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 69.92,
    cy: 87.19,
    r: 4.56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 145.71,
    cy: 96.19,
    r: 4.56
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M76.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCottageCheese);
export default __webpack_public_path__ + "static/media/Cottage_cheese.8c60de4c27f2bad8c1aefee3c9e59ca1.svg";
export { ForwardRef as ReactComponent };